import { Card, CardBody, CardHeader, RiskBadge, StatusBadge } from "@odingard/design-system";
import { EmptyState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { api } from "../../lib/api";
import { CaiError } from "../../components/CaiError";

export function CaiCompliance() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(() => api.compliance(orgId), [orgId]);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Compliance</h1>
          <p>Framework readiness and flow down alerts for government &amp; regulated work.</p>
        </div>
      </div>

      {state.loading && <LoadingState />}
      {state.error && <CaiError error={state.error} onRetry={state.reload} />}
      {state.data && (
        <>
          <div className="metric-grid">
            {state.data.packs.map((p) => (
              <div className="metric-card" key={p.id}>
                <div className="ods-row" style={{ justifyContent: "space-between" }}>
                  <strong>{p.framework}</strong>
                  <StatusBadge status={p.status} />
                </div>
                <div className="progress" style={{ margin: "12px 0 6px" }}>
                  <div
                    className="progress__fill"
                    style={{
                      width: `${p.readiness}%`,
                      background: p.readiness >= 80 ? "var(--ods-color-success)" : p.readiness >= 60 ? "var(--ods-color-warning)" : "var(--ods-color-danger)",
                    }}
                  />
                </div>
                <span style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>
                  {p.readiness}% ready · {p.evidenceCount} evidence items
                </span>
              </div>
            ))}
          </div>

          <Card>
            <CardHeader title="Flow down alerts" />
            <CardBody>
              {state.data.flowDownAlerts.length === 0 ? (
                <EmptyState icon="🛡️" title="No flow down gaps" description="All required clauses are flowing down to subcontracts." />
              ) : (
                <div className="ods-stack">
                  {state.data.flowDownAlerts.map((a) => (
                    <div key={a.id} className="ods-row" style={{ justifyContent: "space-between", borderBottom: "1px solid var(--ods-color-line)", paddingBottom: 10 }}>
                      <div>
                        <div style={{ fontWeight: 600 }}>
                          {a.clauseType}: {a.contractTitle}
                        </div>
                        <span style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>{a.finding}</span>
                      </div>
                      <RiskBadge level={a.riskLevel} />
                    </div>
                  ))}
                </div>
              )}
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
}
